import request from './request';

const transport = {
	async getBusRoutes(query) {
		const response = await request.get('/app/bus-routes', query);
		return response;
	},

	async getBusStops(query) {
		const response = await request.get('/app/bus-stops', query);
		return response;
	},

	async getDestinations(query) {
		const response = await request.get('/app/bus-routes/destinations', query);
		return response;
	},

	async getBusRoutesEta(query) {
		const response = await request.get('/app/bus-routes/eta', query);
		return response;
	},

	async getBusStopsEta(query) {
		const response = await request.get('/app/bus-stops/eta', query);
		return response;
	},

	async getStopsByRouteAndSequence(query) {
		const response = await request.get('/app/bus-route-stops', query);
		return response;
	},

	async getLocations(query) {
		const response = await request.get('/app/locations', query);
		return response;
	},

	async getLocationEta(query) {
		const response = await request.get('/app/locations/eta', query);
		return response;
	},

	async getShuttleSchedules(query) {
		const response = await request.get('/app/shuttle-schedules', query);
		return response;
	}
};

export default transport;
